import useIdentity from "@/features/ui/hooks/use-identity";
import { useMemo } from "react";
import BuyerDashboardPage from "@/features/dashboard/buyer-dashboard-page";
import { Helmet } from "react-helmet-async";
import BoutiqueDashboardPage from "@/features/dashboard/boutique-dashboard-page";
import { getCanonicalUrl } from "@/shared/utils/canonical-url";

export default function DashboardPage() {
  const identity = useIdentity();
  const company = useMemo(() => {
    return identity?.company;
  }, [identity]);

  return (
    <>
      <Helmet>
        <title>Pathrade | Dashboard</title>
        <link
          rel="canonical"
          href={getCanonicalUrl()}
        />
        <meta property="og:title" content="Pathrade | Dashboard" />
        <meta
          property="og:url"
          content={getCanonicalUrl()}
        />
      </Helmet>
      {
        company?.type === "BUYER" && <BuyerDashboardPage />
      }
      {
        company?.type === "BOUTIQUE" && <BoutiqueDashboardPage />
      }
    </>
  );
}
